import lovePng from '@/assets/icons/love.png'
import { pageMaxWidth, socialHandles } from '@/config'
import { CompnayDetail, useCompanyDetail } from '@/features/public'
import { FaFacebook, FaInstagram, FaTiktok, FaYoutube } from 'react-icons/fa'
import { MdLocationPin, MdMail, MdPhone } from 'react-icons/md'
import { Link } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import { Logo, navLinks } from './Navbar'
const openingHours = ['Sunday - Friday (8 AM - 7 PM)', 'Saturday (Closed)']
export const Footer = () => {
  const companyDetail = useCompanyDetail()
  if (companyDetail.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }
  socialHandles.forEach((handle) => {
    if (companyDetail.data) {
      handle.url =
        companyDetail.data[`${handle.title}Link` as keyof CompnayDetail] ||
        handle.url
    }
  })
  return (
    <footer className="w-full">
      <div className="w-full px-[40px] lg:px-[150px]">
        <div
          className={twMerge(
            'mx-auto flex  justify-between pb-[24px] pt-[60px] md:flex-row flex-col gap-y-[24px] md:gap-y-0 ',
            `max-w-[${pageMaxWidth}]`
          )}
        >
          <FooterItemLayout title={Logo}>
            <ul className="flex flex-col gap-y-[12px] px-[5px]">
              <li className="flex items-center gap-x-[10px]">
                <MdLocationPin size={20} />
                {companyDetail.data?.address || ''}
              </li>

              <li className="flex items-center gap-x-[10px]">
                <MdMail size={20} />
                {companyDetail.data?.email || ''}
              </li>

              <li className="flex items-center gap-x-[10px]">
                <MdPhone size={20} />
                {companyDetail.data?.contact || ''}
              </li>
            </ul>
          </FooterItemLayout>
          <FooterItemLayout title={'Quick Links'}>
            <ul className="flex flex-col gap-y-[6px] px-[10px]">
              {navLinks.map(({ name, path }, index) => (
                <Link
                  className="font-nunito text-[16px] font-normal leading-[21.82px] text-[#000000]"
                  key={index}
                  to={path}
                >
                  {name}
                </Link>
              ))}
            </ul>
          </FooterItemLayout>
          <FooterItemLayout title={'Opening Hours'}>
            <ul className="flex flex-col gap-y-[6px] px-[10px]">
              {openingHours.map((item, index) => (
                <li
                  className="font-nunito text-[16px] font-normal leading-[21.82px] text-[#000000]"
                  key={index}
                >
                  {item}
                </li>
              ))}
            </ul>
          </FooterItemLayout>
          <FooterItemLayout title={'Find Us Here'}>
            <ul className="flex gap-x-[12px]">
              {socialHandles.map(({ title, url }, index) => (
                <a href={url} target="_blank" rel="noreferrer" key={index}>
                  {title === 'facebook' ? (
                    <FaFacebook size={19} />
                  ) : title === 'youtube' ? (
                    <FaYoutube size={19} />
                  ) : title === 'instagram' ? (
                    <FaInstagram size={19} />
                  ) : (
                    <FaTiktok size={19} />
                  )}
                </a>
              ))}
            </ul>
          </FooterItemLayout>
        </div>
      </div>
      <div className="w-full border-t border-t-[#8C1D40] px-[40px] py-[10px] md:py-[20px] lg:px-[150px]">
        <div
          className={twMerge(
            'mx-auto flex justify-center items-center gap-y-[5px] md:gap-y-0 flex-col md:flex-row  md:justify-between font-inter text-base font-normal',
            `max-w-[${pageMaxWidth}]`
          )}
        >
          <span className="">Copyright 2024 © - RR Interior Pvt. Ltd.</span>

          <span className="">
            Made with <img src={lovePng} className="inline" /> by Naksa Labs
          </span>
        </div>
      </div>
    </footer>
  )
}

const FooterItemLayout = ({
  children,
  title,
}: {
  children: React.ReactNode
  title: string | React.JSX.Element
}) => {
  return (
    <div className="flex flex-col items-start gap-y-[12px] md:gap-y-[24px] ">
      {typeof title === 'string' ? (
        <span className="font-nunito text-[24px] font-bold leading-[32.74px] text-[#000000]">
          {title}
        </span>
      ) : (
        title
      )}
      {children}
    </div>
  )
}
